import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { baseURL } from "../../../configurations/environment";
import { RequestConfig } from "../../../helpers/RequestConfig";

export const getExcistTrackersRedux = createAsyncThunk(
    "trackers/getexcistTrackers",
    async () => {
        const response = await axios.get(
            `${baseURL}/api/trackers-list`,
            RequestConfig(),
        );
        return response.data && response.data;
    },
);

export const getExcistTrackersWithFilterRedux = createAsyncThunk(
    "trackers/getexcistTrackersWithFilter",
    async (payload) => {
        const response = await axios.get(
            `${baseURL}/api/trackers-list`,
            RequestConfig({
                params: payload,
            }),
        );
        return response.data && response.data;
    },
);

export const getSingleTrackerRedux = createAsyncThunk(
    "tracker/getexcistTrackers",
    async (id, { rejectWithValue, signal }) => {
        try {
            const response = await axios.get(
                `${baseURL}/api/trackers/${id}`,
                RequestConfig({ signal }),
            );
            return response.data && response.data;
        } catch (error) {
            // Let RTK mark the action as aborted (action.meta.aborted) instead of failed.
            if (axios.isCancel(error)) {
                throw error;
            }
            return rejectWithValue({
                ...error?.response?.data,
                status: error?.response?.status,
            });
        }
    },
);
